import { invoiceActions } from "../../actionTypes";

const initialState = {
	invoices: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case invoiceActions.FETCH_INVOICES: {
			return { ...state, ...initialState };
		}

		case invoiceActions.FETCH_INVOICES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				invoices: action.payload,
			};
		}

		case invoiceActions.FETCH_INVOICES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
